// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"table_tableWrapper__2oDUP","rowTitle":"table_rowTitle__27se6","rowData":"table_rowData__1q7Yz","tableHeader":"table_tableHeader__11-vL"};